import React, { Component } from "react";

export class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
    };
  }

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
  };

  render() {
    const { label, onChange, inputValue, maxLength, customClass, placeholder, className } = this.props;
    const { isFocused } = this.state;
    return (
      <div className={`custom-input-container ${customClass} ${isFocused ? "focused" : ""}`}>
        <div className={`text-field-filler ${isFocused && "text-field-filler-pos"}`} />
        <div className="textarea-custom__container">
          <div className="custom-input-label">{label}</div>
          <textarea
            type="text"
            name="value"
            maxLength={maxLength}
            value={inputValue ? inputValue : ""}
            className={`input-filter-comment ${className}`}
            onChange={onChange}
            placeholder={placeholder}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
          />
        </div>
      </div>
    );
  }
}
